module.exports = "<div *ngIf=\"isInitialized\" class=\"main-wrp\">\r\n    <buffer-graph class=\"bg-modal-graph\" [itemId]=\"id\" [dateStart]=\"null\" [dateEnd]=\"null\" [isAdmin]=\"isAdmin\"\r\n                  [type]=\"type\" (showErrors)=\"onShowErrors($event)\"></buffer-graph>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component.html
// module id = ./src/app/buffer-graph/components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component.html
// module chunks = main